import { Component, Input, ViewChild } from '@angular/core';
import { AgprComponentStyleEnum } from '../../../Basic/enums/social-analysis-types.enum';
import { FilterTypesEnum } from '../../enums/filters-types.enum';
import { AbstractFilterTypeComponent } from '../../models/abstract-filter-type.component';
import { FilterTypeModel } from '../../models/abstract-filter-type.model';

@Component({
    selector: 'agpr-filter-wrapper',
    templateUrl: './filter-wrapper.component.html',
    styleUrls: ['./filter-wrapper.component.scss'],
    standalone: false
})

export class FilterWrapperComponent {
    readonly agprComponentStyle = AgprComponentStyleEnum;

    types = FilterTypesEnum;

    @Input() public filter: FilterTypeModel;
    @Input() public id: string;
    @Input() public style: AgprComponentStyleEnum = AgprComponentStyleEnum.social;
    @ViewChild(AbstractFilterTypeComponent) activeFilterComponent: AbstractFilterTypeComponent;

    refresh(): void {
        this.activeFilterComponent?.refresh();
    }
}
